module.exports = __webpack_public_path__ + "static/media/colaboradores.e9be82ec.jpg";